<template>
    <rkm-form ref="RkmForm">
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                v-if="form.papeis.length > 0"
                no-margin-top
                title="Papéis"
            >
                <rkm-form-checkbox-group v-model="model.papeis">
                    <rkm-form-checkbox
                        v-for="papel in form.papeis"
                        :key="papel.id"
                        :label="true"
                        :value="papel.id"
                    >
                        {{papel.nome}}
                    </rkm-form-checkbox>
                </rkm-form-checkbox-group> 
            </rkm-area>

            <rkm-area
                v-if="form.modulos.length > 0"
                no-margin-top
                title="Permissões"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-tabs>
                            <rkm-tab
                                v-for="modulo in form.modulos"
                                :key="modulo.id"
                                :title="modulo.nome"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <rkm-button
                                            @click="handleCheckAll(modulo.id)"
                                            color="primary"
                                            small
                                        >
                                            Marcar todos
                                        </rkm-button>
                                        
                                        <rkm-button
                                            @click="handleUncheckAll(modulo.id)"
                                            outline
                                            small
                                        >
                                            Desmarcar todos
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row cols="3">
                                    <rkm-col
                                        v-for="funcionalidade in modulo.funcionalidades"
                                        :key="funcionalidade.id"
                                    >
                                        <rkm-area
                                            :title="funcionalidade.nome"
                                            no-margin-top
                                        >
                                            <rkm-form-checkbox-group v-model="model.permissoes">
                                                <rkm-form-checkbox
                                                    v-for="permissao in funcionalidade.permissoes"
                                                    :key="permissao.id"
                                                    :label="true"
                                                    :value="permissao.id"
                                                >
                                                    {{ permissao.nome }}
                                                </rkm-form-checkbox>
                                            </rkm-form-checkbox-group>
                                        </rkm-area>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-tab>
                        </rkm-tabs>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-permissao-acesso-form')
        },
    },
    data: () => ({
        form: {
            papeis: [],
            modulos: [],
        },
        model: {
            nome: null,
            papeis: [],
            permissoes: [],
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleCheckAll(modulo_id) {
            this.form.modulos.map(modulo => {
                if (modulo.id === modulo_id) {
                    modulo.funcionalidades.map(funcionalidade => {
                        funcionalidade.permissoes.map(permissao => {
                            if (!this.model.permissoes.includes(permissao.id)) {
                                this.model.permissoes.push(permissao.id)
                            }
                        })
                    })
                }
            })
        },
        handleUncheckAll(modulo_id) {
            this.form.modulos.map(modulo => {
                if (modulo.id === modulo_id) {
                    modulo.funcionalidades.map(funcionalidade => {
                        funcionalidade.permissoes.map(permissao => {
                            const index = this.model.permissoes.findIndex(index => index === permissao.id)

                            if (index >= 0) {
                                this.model.permissoes.splice(index, 1)
                            }
                        })
                    })
                }
            })
        },
        load() {
            this.setLoading('administracao-permissao-acesso-form')

            this.repositories.administracao.permissaoAcesso.edit(this.id)
                .then(({ data }) => {
                    this.form.papeis = data.form.papeis
                    this.form.modulos = data.form.modulos
                    this.model.nome = data.model.nome
                    this.model.papeis = data.model.papeis
                    this.model.permissoes = data.model.permissoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading('administracao-permissao-acesso-form'))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('administracao-permissao-acesso-form')

                        this.repositories.administracao.permissaoAcesso.update(this.model, this.id)
                            .then(({ data }) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('administracao-permissao-acesso-form'))
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number, required: true},
    },
}
</script>